import React, { useMemo, useState } from 'react';

interface UserAvatarProps {
  name?: string;
  picture?: string;
  className?: string;
}

const getInitials = (name?: string): string => {
  if (!name?.trim()) {
    return 'U';
  }

  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 1) {
    return parts[0].slice(0, 2).toUpperCase();
  }

  return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
};

const UserAvatar: React.FC<UserAvatarProps> = ({ name, picture, className = 'user-avatar' }) => {
  const [hasImageError, setHasImageError] = useState(false);
  const initials = useMemo(() => getInitials(name), [name]);
  const shouldShowImage = !!picture && !hasImageError;

  if (shouldShowImage) {
    return (
      <img
        src={picture}
        alt={name || 'User avatar'}
        className={className}
        onError={() => setHasImageError(true)}
      />
    );
  }

  return (
    <div className={`${className} user-avatar-fallback`} aria-label={name || 'User avatar'}>
      {initials}
    </div>
  );
};

export default UserAvatar;
